enum MainGroupersScreensShownEnum {
  PREDICTED_FLOW = 'predicted_flow',
  REALIZED_FLOW = 'realized_flow',
}

export default MainGroupersScreensShownEnum;
